﻿import {JSX} from "react";

export function EmptyComponent(): JSX.Element {
	return <></>;
}
